// Reset Password form

import React, { Component } from 'react';
import { func, object } from 'prop-types';
import { contains } from 'ramda';
import { Link, withRouter } from 'react-router';

// Redux
import { connect } from 'react-redux';
import {checkResetToken, reset} from '../../../actions/password/passwordActions';
import { closeAlertDialog, openSuccessDialog } from '../../../actions/dialog/dialogActions';
import * as PasswordTypes from '../../../actions/password/types';

import LoadingState from '../../LoadingState';
import { setLoggedIn } from '../../../lib/auth';

// Page styles
import cx from 'classnames';
import s from './ResetPasswordForm.css';
import {getEHNACPasswordRequirements, validateEHNACPassword} from "../../../lib/PasswordUtils";


export class ResetPasswordForm extends Component {
  static propTypes = {
    closeAlertDialog: func,
    loading: object,
    location: object,
    history: object,
    match: object,
    openSuccessDialog: func,
    reset: func,
    checkResetToken: func,
  };

  constructor(props) {
    super(props);

    this.state = {
      misMatchError: false,       // Mismatch password messaging
      validPasswordError: false,  // Invalid input messaging
      errorMessage: '',
      patientUuid: null,
      isPasswordRestLinkExpired: false,
    };
  }

  componentDidMount() {
    const requestParams = {
      patientUuid: this.props.params.token
    }

    const successCallback = (response) => {
      this.setState({patientUuid: this.props.params.token});
    }

    const errorCallback = (response) => {
      this.setState({
        isPasswordRestLinkExpired:true
      });

      this.props.router.replace(`/passwordresetlinkexpiration`);
    }

    this.props.checkResetToken(requestParams, successCallback, errorCallback);
  }

  validatePassword = () => {
    const password = this.refs.password.value;
    const confirmPassword = this.refs.confirmPassword.value;
    const validInput = validateEHNACPassword(password);

    if (password !== confirmPassword) {

      this.setState({ misMatchError: true, });

    } else if (!validInput){

      this.setState({
        misMatchError: false,
        validPasswordError: true,
      });

    } else {

      this.setState({
        misMatchError: false,
        validPasswordError: false,
      });

      return true;
    }
  }

  isLoading = (loading) => contains(PasswordTypes.RESET_PASSWORD_REQUEST, loading.requests);

  // Display success dialog. okCallback invokes route change.
  handleConfirmPassword = (e) => {
    e.preventDefault();

    const isValid = this.validatePassword();
    const password = this.refs.password.value;

    if (isValid) {

      const successCallback = response =>
        this.props.openSuccessDialog({
          title: 'Password reset successfully!',
          okCallback: () => {
            this.props.closeAlertDialog();
            this.handlePasswordResetSuccess(response);
          },
        });

      const errorCallback = response => this.setState({ errorMessage: response.message.body });

      const patientUuid = this.state.patientUuid;

      const params = {password, patientUuid};

      this.props.reset(params, successCallback, errorCallback);
    }
  }

  handlePasswordResetSuccess = response => {
    const route = response.route;
    setLoggedIn(route, response.logoutUrl);

    /**
     * Successful responses return a route (home, resetpassword, etc.) indicating
     * where to transition the end user to based on a calculated session state
     * from the server side.
     */
    this.props.router.replace(`/${route}`);
  };

  render = () => {
    const isLoading = this.isLoading(this.props.loading);

    return (
      <section className={s.component} id="resetPasswordFormComponent">
        <h3 className={s.header}>
          Create a New Password
        </h3>
        <form
          id="resetPasswordForm"
          className={s.form}
          onSubmit={this.handleConfirmPassword}
          method="post"
        >
          <div className={s.groupStacked}>
            <p className={s.helpText}>
              {getEHNACPasswordRequirements()}
            </p>
          </div>
          <div className={s.groupStacked}>
            <label className={s.label} htmlFor="password">
              New Password
            </label>
            <input
              id="password"
              type="password"
              ref="password"
              name="password"
              className={s.control}
              required
            />
          </div>
          <div className={s.groupStacked}>
            <label className={s.label} htmlFor="confirmPassword">
              Confirm Password
            </label>
            <input
              id="confirmPassword"
              type="password"
              ref="confirmPassword"
              name="confirmPassword"
              className={s.control}
              required
            />
          </div>
          <div className={cx(s.groupStacked, s.margins)}>
            <button
              id="submitResetPassword"
              type="submit"
              className={s.btn}
              disabled={isLoading}
            >
              {isLoading ? (
                <LoadingState context="resetPasswordForm" />
              ) : (
                'Confirm'
              )}
            </button>
            <Link
              id="cancelResetPassword"
              title="Cancel"
              to={`/login`}
              className={s.cta}
            >
              Cancel
            </Link>
          </div>
          {this.state.misMatchError &&
            <p className={s.message}>
              New and Confirm Password fields do not match. Please try again.
            </p>
          }
          {this.state.validPasswordError &&
            <p className={s.message}>
              Your password isn't strong enough. Please review the password requirements and try again.
              {getEHNACPasswordRequirements()}
            </p>
          }
          {this.state.errorMessage &&
            <p className={s.message}>
              {this.state.errorMessage}
            </p>
          }
        </form>
      </section>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.loadingState,
});

const mapDispatchToProps = dispatch => ({
  closeAlertDialog: () => dispatch(closeAlertDialog()),
  reset: (password, successCb, errorCb) => dispatch(reset(password, successCb, errorCb)),
  checkResetToken: (patientUuid, successCb, errorCb) => dispatch(checkResetToken(patientUuid, successCb, errorCb)),
  openSuccessDialog: (dialog) => dispatch(openSuccessDialog(dialog)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ResetPasswordForm));



// WEBPACK FOOTER //
// ./src/components/Pages/ResetPassword/ResetPasswordForm.js